import React, { useEffect, useState } from "react";
import { Form, Input, Button, Card } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../components/utils/LoadingSpinner";
import getDataById from "../../../hooks/admin/getDataById";

const EditVendor = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { id } = useParams();
  const user = JSON.parse(localStorage.getItem("admin"));

  useEffect(() => {
    const getById = async () => {
      try {
        const response = await getDataById("admin/getbyidvendor", id);
        if (response.status_code === 200) {
          const { vendor_name, vendor_email, vendor_contact } = response.data;
          form.setFieldsValue({
            vendor_name,
            vendor_email,
            vendor_contact,
          });
        }
      } catch (err) {
        toast.error("Failed to load vendor data");
      }
      setLoading(false);
    };
    getById();
  }, [id, form]);

  const onFinish = async (values) => {
    const payload = { ...values, vendor_id: parseInt(id) };

    const res = await fetch(
      `${process.env.REACT_APP_APIURL}/admin/updatevendor`,
      {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );

    const response = await res.json();

    if (response?.status_code === 200) {
      toast.success("Vendor updated successfully");
      navigate("/admin/vendors");
    } else {
      toast.error("Something went wrong");
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <h2 className="text-title text-lg md:text-2xl pb-2">Edit Vendor</h2>
      <Card className="max-w-xl mx-auto shadow-sm">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            name="vendor_name"
            label="Vendor Name"
            rules={[{ required: true, message: "Please enter vendor name" }]}
          >
            <Input placeholder="Enter vendor name" />
          </Form.Item>

          <Form.Item
            name="vendor_email"
            label="Email"
            rules={[
              { required: true, message: "Please enter email" },
              { type: "email", message: "Enter a valid email" },
            ]}
          >
            <Input placeholder="Enter email address" />
          </Form.Item>

          <Form.Item
            name="vendor_contact"
            label="Contact"
            rules={[
              { required: true, message: "Please enter contact number" },
            ]}
          >
            <Input type="tel" placeholder="Enter contact number" />
          </Form.Item>

          <div className="flex justify-end gap-4 mt-4">
            <Link to="/admin/vendors">
              <Button danger>Cancel</Button>
            </Link>
            <button className="btn btn-primary btn-sm text-white" type="submit" >
              Save
            </button>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default EditVendor;

